import React, { FC } from 'react';
import { Button, Label } from '../../atoms';
import BaseTemplate from '../BaseTemplate';

import styles from './ReportingDetailsIndicatorsTemplate.module.css';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';
import { useNavigate } from 'react-router-dom';
import { ReportingDetailsIndicatorsOrganism } from '../../organisms';
import { Container } from 'react-bootstrap';

export interface ReportingDetailsIndicatorsTemplateProps {
  data: IndicatorResponseDto[];
  handleDeleteIndicator: (id: string) => void;
}

const ReportingDetailsIndicatorsTemplate: FC<
  ReportingDetailsIndicatorsTemplateProps
> = ({ data, handleDeleteIndicator }) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label content="Progress Reporting - Indicators" size="lg" />
          <Button
            variant={'dark'}
            onClick={() => navigate('/reporting-details/indicators/add')}
          >
            Add Indicator
          </Button>
        </div>
        <ReportingDetailsIndicatorsOrganism
          data={data}
          handleDeleteIndicator={handleDeleteIndicator}
        />
      </Container>
    </BaseTemplate>
  );
};

export default ReportingDetailsIndicatorsTemplate;
